/**
 * Styled native multiline input forwarding textarea attributes and its element ref.
 *
 * @module apps/web/src/components/ui/textarea
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Native HTML textarea attributes accepted by the shared textarea.
 */
export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

/**
 * Ref-forwarding multiline input with shared focus, border, and disabled styles.
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
